<template lang="html">
  <div class="exact-sales">
    <div class="widget">
      <div class="widget-body">
        <div class="d-flex justify-content-between align-items-center">
          <div class="state">
            <h4>Integração Gravações - Cloud<small v-if="!activeIntegration">(Inativo)</small></h4>
          </div>
          <div class="icon">
            <div v-if="activeIntegration">
              <font
                title="Configurações"
                size="6"
                color="black"
                @click.prevent="toogleUpdateIntegration()">
                <i class="ik ik-settings" />
              </font>
            </div>
            <div v-else>
              <font
                title="Configurações"
                size="6"
                color="gray">
                <i class="ik ik-settings" />
              </font>
            </div>
          </div>
        </div>
        <div class="d-flex justify-content-between align-items-center">
          <small class="text-small mt-10 d-block">
            <toggle-button
              tag="copy-recordings"
              class="mb-1"
              :width="90"
              :height="30"
              :font-size="15"
              :value="activeIntegration"
              :sync="true"
              :labels="{checked: 'Ativo', unchecked: 'Ativar'}"
              @change="toogleIntegration" />
          </small>
          <!-- <font
            title="Tutorial"
            size="6"
            color="black"
            @click.prevent="openTutorial">
            <i class="ik ik-youtube" />
          </font> -->
        </div>
      </div>
    </div>
    <div
      class="modal fade"
      tabindex="-1"
      role="dialog"
      id="confirmDelete"
      ref="confirmDelete"
      data-keyboard="false"
      data-backdrop="static"
      aria-hidden="true">
      <div
        class="modal-dialog modal-dialog-centered"
        role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <h4 class="modal-title">Você tem certeza que deseja remover a integração com a cloud?</h4>
          </div>
          <div class="modal-footer">
            <div class="buttons">
              <button
                type="button"
                class="btn btn-outline-secondary"
                data-dismiss="modal">Não</button>
              <button
                type="button"
                class="btn btn-primary"
                @click.prevent="deleteIntegration">Sim</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal fade"
      tabindex="-1"
      role="dialog"
      id="updateIntegration"
      ref="updateIntegration"
      data-keyboard="false"
      data-backdrop="static"
      aria-hidden="true">
      <div
        class="modal-dialog modal-dialog-centered"
        role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">Configurar Integração Cloud - Gravações</h4>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div
              v-if="error"
              class="alert alert-danger"
              role="alert">
              <span v-html="error.message" />
            </div>
            <div class="form-group row">
              <label class="col-sm-4 col-form-label">Cloud</label>
              <div class="col-sm-8">
                <select
                  class="form-control"
                  id="cloudSelected"
                  v-model="cloudSelected"
                  @change="toggleCloudConfiguration">
                  <option
                    v-for="option in cloudSelectedOptions"
                    :key="option.value"
                    :value="option.value">
                    {{ option.text }}
                  </option>
                </select>
              </div>
            </div>
            <p class="text-center">
              <a
                v-if="cloudSelected === 'api4com'"
                class="link">
                Api4Com
              </a>
              <a
                v-else-if="cloudSelected === 'gcp'"
                class="link"
                href="https://google.com"
                target="_blank">
                Google - GCP
              </a>
              <a
                v-else-if="cloudSelected === 'aws'"
                class="link"
                href="https://aws.com"
                target="_blank">
                AWS S3
              </a>
            </p>
            <div
              v-if="cloudSelected === 'aws'"
              class="form-group row">
              <label
                for="awsAccessKey"
                class="col-sm-4 col-form-label">Access Key</label>
              <div class="col-sm-8">
                <input
                  id="awsAccessKey"
                  type="password"
                  class="form-control"
                  tabindex="3"
                  v-model="awsAccessKey">
              </div>
              <label
                for="awsSecretAccessKey"
                class="col-sm-4 col-form-label">Secret Access Key</label>
              <div class="col-sm-8">
                <input
                  id="awsSecretAccessKey"
                  type="password"
                  class="form-control"
                  tabindex="3"
                  v-model="awsSecretAccessKey">
              </div>
              <label
                for="awsBucketName"
                class="col-sm-4 col-form-label">Bucket Name</label>
              <div class="col-sm-8">
                <input
                  id="awsBucketName"
                  type="text"
                  class="form-control"
                  tabindex="3"
                  v-model="awsBucketName">
              </div>
            </div>
            <div
              v-else-if="cloudSelected === 'gcp'"
              class="form-group row">
              <label
                for="gcpJsonData"
                class="col-sm-4 col-form-label">JSON content</label>
              <div class="col-sm-8">
                <textarea
                  id="gcpJsonData"
                  rows="4"
                  cols="50"
                  class="form-control"
                  tabindex="3"
                  v-model="gcpJsonData"/>
              </div>
              <label
                for="gcpPathName"
                class="col-sm-4 col-form-label">Bucket Name</label>
              <div class="col-sm-8">
                <input
                  id="gcpPathName"
                  type="text"
                  class="form-control"
                  tabindex="3"
                  v-model="gcpPathName">
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <div class="buttons">
              <button
                type="button"
                class="btn btn-primary"
                :disabled="!configReady"
                @click.prevent="saveIntegration">{{ labelSubmit }}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal fade"
      tabindex="-1"
      role="dialog"
      id="successIntegration"
      ref="successIntegration"
      data-keyboard="false"
      data-backdrop="static"
      aria-hidden="true">
      <div
        class="modal-dialog modal-sm modal-dialog-centered"
        role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body text-center">
            <h5 class="modal-title">Integração de Gravações com a Cloud atualizada com sucesso!</h5>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-outline-secondary"
              data-dismiss="modal">OK</button>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal fade"
      tabindex="-1"
      role="dialog"
      id="uninstallIntegration"
      ref="uninstallIntegration"
      data-keyboard="false"
      data-backdrop="static"
      aria-hidden="true">
      <div
        class="modal-dialog modal-sm modal-dialog-centered"
        role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body text-center">
            <h5 class="modal-title">Integração de Gravações removida com sucesso!</h5>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-outline-secondary"
              data-dismiss="modal">OK</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import loopback from '@/services/loopback'

export default {
  name: 'IntegrationCloudRecordings',
  data () {
    return {
      error: null,
      integration: null,
      configReady: false,
      security: null,
      gcpJsonData: null,
      awsAccessKey: null,
      awsSecretAccessKey: null,
      awsBucketName: null,
      gcpPathName: null,
      bucketName: null,
      ownStorage: false,
      cloudSelected: 'api4com',
      cloudSelectedOptions: [
        { value: 'api4com', text: 'Api4Com' },
        { value: 'gcp', text: 'Google Cloud Storage' },
        { value: 'aws', text: 'AWS S3' }
      ]
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.loadIntegration()
      this.cloudValidator()
    })
  },
  methods: {
    loadIntegration () {
      return loopback
        .get(`/organization_integrations?filter[where][gateway]=recordings_cloud`)
        .then(integrations => {
          this.integration = integrations.pop()
          if (this.integration && this.integration.metadata) {
            if (this.integration.metadata.cloudSelected) this.cloudSelected = this.integration.metadata.cloudSelected
            if (this.integration.metadata.cloudSelected === 'aws') {
              this.awsAccessKey = this.integration.metadata.security.aws_access_key_id
              this.awsSecretAccessKey = this.integration.metadata.security.aws_secret_access_key
              this.awsBucketName = this.integration.metadata.bucketName
            } else if (this.integration.metadata.cloudSelected === 'gcp') {
              this.gcpJsonData = this.integration.metadata.security
              this.gcpPathName = this.integration.metadata.bucketName
            }
          }
        })
        .catch(err => { this.$emit('onError', err) })
    },

    saveIntegration () {
      if (this.cloudSelected && this.configReady) {
        this.error = null
        if (this.cloudSelected === 'gcp') {
          this.security = this.gcpJsonData
          this.bucketName = this.gcpPathName
          this.ownStorage = true
        } else if (this.cloudSelected === 'aws') {
          this.security = {
            aws_access_key_id: this.awsAccessKey,
            aws_secret_access_key: this.awsSecretAccessKey
          }
          this.bucketName = this.awsBucketName
          this.ownStorage = true
        } else if (this.cloudSelected === 'api4com') {
          this.security = {
            aws_access_key_id: process.env.API4COM_SECURITY_DATA.aws_access_key_id,
            aws_secret_access_key: process.env.API4COM_SECURITY_DATA.aws_secret_access_key
          }
          this.bucketName = process.env.API4COM_SECURITY_DATA.bucket_name
          this.ownStorage = false
        }
        const integrationParams = {
          gateway: 'recordings_cloud',
          webhook: false,
          metadata: {
            cloudSelected: this.cloudSelected,
            version: 'v1.0',
            mustPurgeAfterUpload: false,
            security: this.security,
            ownStorage: this.ownStorage,
            bucketName: this.bucketName
          }
        }
        if (this.integration) integrationParams.id = this.integration.id
        loopback
          .patch('/organization_integrations', integrationParams)
          .then(integration => {
            this.integration = integration
            $(this.$refs.updateIntegration).modal('hide')
            $(this.$refs.successIntegration).modal('show')
          })
          .catch(err => {
            this.error = err
            if (err && err.details) {
              this.error = {
                message: Object.values(err.details.messages).join('<br />')
              }
            }
          })
      } else {
        this.error = {
          message: 'Cloud é obrigatório'
        }
      }
    },

    toggleCloudConfiguration (event) {
      if (event.target) {
        // Loop em todos os itens para esconder todos //
        document.querySelectorAll(`.cloudSelector`).forEach(e => {
          e.style.display = 'none'
        })
        // Apresenta o item //
        document.querySelector(`#${event.target.selectedOptions[0]._value}`).style.display = 'block'
      }
    },

    toogleIntegration (event) {
      if (event.value === true) {
        $(this.$refs.updateIntegration).modal('show')
      } else {
        $(this.$refs.confirmDelete).modal('show')
      }
    },

    toogleUpdateIntegration () {
      $(this.$refs.updateIntegration).modal('show')
    },

    deleteIntegration () {
      if (!this.integration) return
      loopback
        .delete(`/organization_integrations/${this.integration.id}`)
        .then(_ => {
          this.integration = null
          this.cloudSelected = this.cloudSelected
          this.error = null
          this.configReady = false
          $(this.$refs.uninstallIntegration).modal('show')
        })
        .finally(_ => {
          $(this.$refs.confirmDelete).modal('hide')
        })
        .catch(err => { this.$emit('onError', err) })
    },

    openTutorial () {
      $(this.$refs.tutorialExactSales).modal('show')
    },

    cloudValidator () {
      if (this.cloudSelected === 'aws') {
        this.configReady = (this.awsAccessKey && this.awsSecretAccessKey && this.awsBucketName)
      } else if (this.cloudSelected === 'gcp') {
        this.configReady = (this.gcpJsonData && this.gcpPathName)
      } else {
        this.configReady = this.cloudSelected === 'api4com'
      }
    }
  },
  computed: {
    activeIntegration () {
      return this.integration && this.integration.gateway === 'recordings_cloud'
    },

    labelSubmit () {
      return this.activeIntegration ? 'Salvar' : 'Ativar'
    }
  },
  watch: {
    cloudSelected: function () {
      this.cloudValidator()
    },
    gcpJsonData: function () {
      this.cloudValidator()
    },
    gcpPathName: function () {
      this.cloudValidator()
    },
    awsAccessKey: function () {
      this.cloudValidator()
    },
    awsSecretAccessKey: function () {
      this.cloudValidator()
    },
    awsBucketName: function () {
      this.cloudValidator()
    }
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/Integration/CopyRecordings.vue